module.exports = __webpack_public_path__ + "static/img/330.cc2b7061.png";